import React from 'react'
import OverlayItems from './OverlayItems'
import {
  getSubscriptionPlans,
  getInvisiblePlans
} from "~/redux/user/subscription";
import _ from 'lodash'
import './style.css'

// const TVODMap = {
//  rent: title => `When you rent ${title}, you have 30 days to begin your 48 hour rental period. Once your 48 hour rental is started you can watch the ${title} as much as you want.`,
//  purchase: title => `When you purchase ${title}, you can watch this ${title} whenever you want.`
// }

class Overlay extends React.Component {
  constructor(props){
    super()
    this.pricing = props.content.pricing
    let pricing = Overlay.formatPricing(this.pricing, props.content.gist.id, props.content.gist.title || props.content.gist.description);
    this.state = { selected: 0, items: pricing, plans: [], planSelected:0 };
  }

  componentDidMount() {
    const type = this.props.model || this.props.content.pricing.type
      if (type && type.includes('SVOD')) {
      if (!window.sessionStorage.getItem('plans')) {
        getSubscriptionPlans().then(plans => {
          this.setState({ plans })
        })
      } else {
        getInvisiblePlans().then(plans => {
          this.setState({ plans })
        })
      }
    }

    this.setState({ type })
  }

  static formatPricing(pricing, id, title) {
    function firstLetterUppercase(str) {
      return str.charAt(0).toUpperCase().concat(str.substring(1))
    }

    const items = []
    const contentTitle = window.settings.internalName.includes('supercrosslive') ?
    'Single Event' : `${title} |`
    Object.keys(pricing).forEach(option => {
      if (pricing[option] && option !== 'type' && option !== 'currency') {
        const optionKeys = Object.keys(pricing[option]);
        optionKeys.forEach(key => {
          if (pricing[option][key]) {
            let obj = {};
            obj.key = key.toUpperCase()
            obj.videoID = id;
            obj.contentID = id.content;
            if (_.isObject(id)) {
              obj.videoID = id.video ? id.video : id.items ? id.items.join(',') : null
              obj.contentID = id.content
              obj.seriesId = id.series ? id.series : null 
              obj.seasonId = id.season ? id.season : null
            }
            obj.option = firstLetterUppercase(option);
            obj.price = pricing[option][key];
            //obj.description = TVODMap[option](title);
            obj.name = `${contentTitle} ${obj.option} $${obj.price}`;
            items.push(obj);
          }
        });
      }
    })
    return items
  }

  selected(i){
    this.setState({
      selected: i
    })
  }

  planSelected = i => {
    this.setState({
      planSelected: i
    })
  }

  render() {
    const { plans, items, type } = this.state
    const label = type && type === 'TVOD' ? 'Purchase' : 'Rent / Purchase'
    const isSVOD = type && type === 'SVOD'
    return (
      <div className={`overlay-video-container ${plans.length > 0 && !isSVOD && 'subscriptions'}`}>
        { !isSVOD && <OverlayItems title={label} items={items} {...this.props}/> }
        { plans.length > 0 &&
          <OverlayItems 
            title='Subscribe' 
            items={plans} 
            subscriptionPlans={true}
            {...this.props} 
          />
        }
      </div>
    )
  }

}

export default Overlay